/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_No_RequestsInputs */

const en_follow_no_requests = /** @type {(inputs: Follow_No_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pending follow requests`)
};

const es_follow_no_requests = /** @type {(inputs: Follow_No_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay solicitudes pendientes`)
};

const fr_follow_no_requests = /** @type {(inputs: Follow_No_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune demande d'abonnement en attente`)
};

const de_follow_no_requests = /** @type {(inputs: Follow_No_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine ausstehenden Anfragen`)
};

const id_follow_no_requests = /** @type {(inputs: Follow_No_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada permintaan ikuti tertunda`)
};

/** @type {(inputs: Follow_No_RequestsInputs) => LocalizedString} */
const ja_follow_no_requests = en_follow_no_requests;

/** @type {(inputs: Follow_No_RequestsInputs) => LocalizedString} */
const zh_follow_no_requests = en_follow_no_requests;

/** @type {(inputs: Follow_No_RequestsInputs) => LocalizedString} */
const ar_follow_no_requests = en_follow_no_requests;

/** @type {(inputs: Follow_No_RequestsInputs) => LocalizedString} */
const it_follow_no_requests = en_follow_no_requests;

/** @type {(inputs: Follow_No_RequestsInputs) => LocalizedString} */
const ru_follow_no_requests = en_follow_no_requests;

/** @type {(inputs: Follow_No_RequestsInputs) => LocalizedString} */
const pt_follow_no_requests = en_follow_no_requests;

/** @type {(inputs: Follow_No_RequestsInputs) => LocalizedString} */
const ko_follow_no_requests = en_follow_no_requests;

/**
* | output |
* | --- |
* | "No pending follow requests" |
*
* @param {Follow_No_RequestsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const follow_no_requests = /** @type {((inputs?: Follow_No_RequestsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_No_RequestsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follow_no_requests(inputs)
	if (locale === "es") return es_follow_no_requests(inputs)
	if (locale === "fr") return fr_follow_no_requests(inputs)
	if (locale === "de") return de_follow_no_requests(inputs)
	if (locale === "ja") return ja_follow_no_requests(inputs)
	if (locale === "zh") return zh_follow_no_requests(inputs)
	if (locale === "ar") return ar_follow_no_requests(inputs)
	if (locale === "id") return id_follow_no_requests(inputs)
	if (locale === "it") return it_follow_no_requests(inputs)
	if (locale === "ru") return ru_follow_no_requests(inputs)
	if (locale === "pt") return pt_follow_no_requests(inputs)
	return ko_follow_no_requests(inputs)
});